fx.ns("desktop.book.edition", class CreateAlbumToolTip extends fx.Component{

    constructor(data)
    {
        super(data);

        this.effect = "hslidein";
    }

    create()
    {
        this.personImage = new fx.components.Image({data : fx.get("assets").splashPhoto, className : "image"});
        this.addChild(this.personImage,  {width : 80, height : 80, left : 10, top : 10});

        let text = new fx.components.Text(fx.text("Je peux créer votre album pour vous !"));
        this.addChild(text,  {width : 270, height : 30, left : 110, top : 15});

        this.createButton = new fx.components.Button({label : fx.text("Oui, c'est parti !"), type : "filled"});
        this.addChild(this.createButton,  {width : 270, height : 50, left : 100, top : 35});

        this.triangle = new fx.components.Box("triangle");
        this.addChild(this.triangle, { width : 0, height : 0, top : 32.5, left : -35});
    }

    onReady()
    {
        this.on("click", this._onCreate, this.createButton);
    }

    _onCreate()
    {
        this.data.event("place-photos-chronologically");
    }
});